<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [timeToComplete]="this.uiLoadingIndicatorTimeout"
  [transparentOverlay]="true"
  >
  @if (gridOptions) {
    <lm-list-datagrid-wrapper #DatagridWrapper
      [dataGridId]="dataGridId"
      [dataGridAutomationId]="dataGridAutomationId"
      [dataset]="treeData"
      [emptyMessage]="emptyMessage"
      [gridOptions]="gridOptions"
      (filtered)="onColumnFiltered($event)"
      (cellchange)="onCellChange($event)"
      (contextMenu)="onContextMenu($event)"
      (rowClicked)="onRowClicked($event)"
      (rowDoubleClicked)="onRowDoubleClicked($event)"
      (closeFilterRow)="onCloseFilterRow($event)"
      (openFilterRow)="onOpenFilterRow($event)"
      (selected)="onRowsSelected($event)"
      (expandrow)="onExpandRow($event)"
      (collapserow)="onCollapseRow($event)"
      (rowActivated)="onRowActivated($event)"
      (keydown)="onKeyDown($event)"
      (filteroperatorchanged)="onFilterOperatorChanged($event)"
    ></lm-list-datagrid-wrapper>
  }
</div>
